import { render, staticRenderFns } from "./GlobalAcquisition.vue?vue&type=template&id=2b4f0350&scoped=true"
import script from "./GlobalAcquisition.vue?vue&type=script&lang=js"
export * from "./GlobalAcquisition.vue?vue&type=script&lang=js"
import style0 from "./GlobalAcquisition.vue?vue&type=style&index=0&id=2b4f0350&prod&scoped=true&lang=css"
import style1 from "./GlobalAcquisition.vue?vue&type=style&index=1&id=2b4f0350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f0350",
  null
  
)

export default component.exports